export default {
      id: "ic_bilyoner_logo_circle-usage",
      viewBox: "0 0 50 39",
      url: "/" + "images/icons.3.109.2.svg#ic_bilyoner_logo_circle-usage",
      toString: function () {
        return this.url;
      }
    }